import useTitle from "../../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams } from "react-router-dom"
import { useGetTasksQuery } from '../../tasks/tasksApiSlice'
import { useState } from "react"
import StudentGradesList from "./StudentGradesList"
function StudentGradesListFilter() {
    useTitle('geshtop-Exercise: Grades List')
    const { groupId} = useParams()
    const { tasks } = useGetTasksQuery("tasksList", {
        selectFromResult: ({ data }) => ({
            tasks: data?.ids.map(id => data?.entities[id])
        }),
    })
    const navigate = useNavigate()
    const[task,setTask] = useState('')
    //if (!tasks?.length) return <PulseLoader color={"#FFF"} />
    let options =[]
    if(tasks?.length){
    const filterTasks = groupId!=='0'? tasks.filter(task=>task.group===groupId) : [...tasks]
    options = filterTasks?.map(task => {
        return (
            <option
                key={task.id}
                value={task.id}
            >{task.title} {task.groupname && ` - ${task.groupname}`} </option >
        )
    })
    }
   
   
    const content =(<>
    <div className="filter-form">
        <div className="filter-form-item">
            <div className="form-input-container">
                    <select
                        id="task"
                        name="task"
                        className={`form__input`}
                        value={task}
                        onChange={(e)=>setTask(e.target.value)}
                    >
                        <option value="">--בחר משימה--</option>
                        {options}
                    </select>
                </div>

        </div>

    </div>
 <StudentGradesList task={task} /> 

</> ) 
  return content;
}

export default StudentGradesListFilter